import React, { memo } from 'react';
import IssueAssigneeField from '@atlassian/jira-issue-field-assignee';
import { PaddedFlexContainer } from '../../../common/ui/styled';
import { preventDefault, stopPropagation } from '../../../common/utils';
import type { Props } from './types';

export const InteractiveAssignee = memo<Props>(({ issueKey, onUpdate }: Props) => (
	<PaddedFlexContainer role="button" onClick={preventDefault} onFocus={stopPropagation}>
		<IssueAssigneeField issueKey={issueKey} onUpdate={onUpdate} />
	</PaddedFlexContainer>
));
